import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Spacer from './Spacer';

/** Re-exports `Spacer` with a preset style for use on the eSports landing page */
const PrizeSpacer = props => {
    const { className, ...otherProps } = props;

    return (
        <Spacer
            className={cx('prize-spacer', 'mbl__spacer', className)}
            padding={40}
            {...otherProps}
        />
    );
};

PrizeSpacer.displayName = 'PrizeSpacer';

PrizeSpacer.propTypes = {
    className: PropTypes.string
};

export default PrizeSpacer;
